/**
 * Deep-merge plain objects (for locale message overrides).
 * Arrays and non-plain objects are replaced, not merged.
 */
export function deepMerge(base, patch) {
  if (patch === undefined || patch === null) return base;
  if (typeof patch !== "object" || Array.isArray(patch)) return patch;
  const out = Array.isArray(base) ? [...base] : { ...base };
  for (const k of Object.keys(patch)) {
    const pv = patch[k];
    const bv = base[k];
    if (
      pv &&
      typeof pv === "object" &&
      !Array.isArray(pv) &&
      Object.getPrototypeOf(pv) === Object.prototype &&
      bv &&
      typeof bv === "object" &&
      !Array.isArray(bv) &&
      Object.getPrototypeOf(bv) === Object.prototype
    ) {
      out[k] = deepMerge(bv, pv);
    } else {
      out[k] = pv;
    }
  }
  return out;
}
